module.exports = __webpack_public_path__ + "static/3-e2a717a0f16b9fc29605e0b11e3bfa0a.jpg";